import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Rules from './pages/Rules';
import Store from './pages/Store';
import Staff from './pages/Staff';
import Vote from './pages/Vote';
import FAQ from './pages/FAQ';
import config from './config';

const GlobalStyle = createGlobalStyle`
  :root {
    --primary-color: ${props => props.theme.primaryColor};
    --secondary-color: ${props => props.theme.secondaryColor};
    --accent-color: ${props => props.theme.accentColor};
    --dark-color: ${props => props.theme.darkColor};
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Poppins', sans-serif;
    background: radial-gradient(
      circle at 50% 50%,
      rgba(255, 51, 51, 0.15) 0%,
      rgba(0, 0, 0, 0.9) 70%
    ), var(--dark-color);
    color: #fff;
    min-height: 100vh;
    position: relative;
  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    position: relative;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Poppins', sans-serif;
  }

  a {
    text-decoration: none;
  }
`;

function App() {
  return (
    <ThemeProvider theme={config.theme}>
      <Router>
        <GlobalStyle />
        <Navbar 
          serverName={config.serverName} 
          navigation={config.navigation} 
          externalLinks={config.externalLinks} 
        />
        <Routes>
          <Route path="/" element={<Home serverName={config.serverName} serverIP={config.serverIP} discordInvite={config.discordInvite} />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/store" element={<Store />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/vote" element={<Vote />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
        <Footer serverName={config.serverName} socialLinks={config.socialLinks} />
      </Router>
    </ThemeProvider>
  );
}

export default App;